import styled from 'styled-components';
import { Card } from 'antd';
import { COLORS } from '../../constants/colors';

export const PageContainer = styled.div`
  padding: 32px;
  background: ${COLORS.backgroundLight};
  min-height: calc(100vh - 80px);

  @media (max-width: 768px) {
    padding: 20px;
  }
`;

export const PatientInfoCard = styled(Card)`
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border: none;

  .ant-card-body {
    padding: 24px;
  }

  @media (max-width: 768px) {
    .ant-card-body {
      padding: 16px;
    }
  }
`;

export const FormContainer = styled.div`
  .ant-card {
    border-radius: 12px;
  }

  .ant-card-head {
    border-bottom: 2px solid ${COLORS.border};
    
    .ant-card-head-title {
      color: ${COLORS.textDark};
      font-weight: 600;
      font-size: 18px;
    }
  }

  .ant-card-body {
    padding: 32px;

    @media (max-width: 768px) {
      padding: 20px;
    }
  }
`;
